var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrSouparceiroIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,10,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,10,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,10,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,10,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,10,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,10,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,20,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,20,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,20,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,20,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,20,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,20,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,20,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,30,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,30,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,30,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,30,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,30,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,30,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,30,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,30,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,30,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,40,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,40,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,40,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,40,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,40,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,40,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,40,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,40,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,50,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,50,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,50,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,50,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,50,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,50,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,60,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,60,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,60,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,60,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,60,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,60,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,60,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,60,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,70,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,70,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,70,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,70,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,70,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,70,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,70,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,80,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,80,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,80,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,80,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,80,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,90,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,90,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,90,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,90,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,90,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,90,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,90,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,90,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,90,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,90,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,90,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,90,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,90,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,90,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,100,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,100,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,100,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,100,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,100,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,100,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,100,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,100,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,100,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,100,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,100,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,100,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,100,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,100,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,100,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,100,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,110,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,110,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,110,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,110,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,110,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,110,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,110,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,110,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,110,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,110,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,110,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,110,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,110,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,110,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,110,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,110,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,110,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,120,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,120,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,120,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,120,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,120,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,120,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,120,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,120,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,120,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,120,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,120,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,120,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,120,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,130,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,130,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,130,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,130,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,130,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,130,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,130,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,130,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,130,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,130,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,130,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,130,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,130,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,130,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,130,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,130,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,130,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,140,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,140,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,140,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,140,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,140,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,140,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,140,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,140,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,140,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,140,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,140,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,140,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,140,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,140,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,140,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,150,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,150,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,150,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,150,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,150,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,150,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,150,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,150,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,150,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,150,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,150,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,150,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,150,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,150,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,150,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,160,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,160,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,160,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,160,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,160,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,160,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,160,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,160,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,160,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,160,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,160,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,160,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,160,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,170,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,170,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,170,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,170,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,170,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,170,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,170,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,170,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,170,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,170,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,170,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,170,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,170,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,170,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,170,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,170,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,180,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,180,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,180,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,180,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,180,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,180,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,180,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,180,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,180,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,180,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,180,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,180,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,180,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,180,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,180,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,180,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,190,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,190,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,190,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,190,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,190,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,190,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,190,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,190,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,190,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,190,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,190,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,190,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,190,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,200,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,200,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,200,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,200,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,200,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,200,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,200,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,200,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,200,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,200,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,200,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,200,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,200,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,200,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,200,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,200,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,200,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,200,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,210,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,210,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,210,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,210,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,210,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,210,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,210,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,210,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,210,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,210,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,210,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,210,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,210,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,210,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,210,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,220,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,220,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,220,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,220,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,220,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,220,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,220,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,220,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,220,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,220,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,220,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,220,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,220,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,230,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,230,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,230,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,230,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,230,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,230,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,230,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,230,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,230,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,230,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,230,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,230,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,240,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,240,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,240,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,240,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,240,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,240,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,240,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,240,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,250,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,250,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,250,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,250,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,250,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,250,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,250,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,250,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,250,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,250,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,250,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,250,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,250,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,250,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,250,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,260,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,260,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,260,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,260,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,260,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,260,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,260,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,260,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,260,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,270,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,270,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,270,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,270,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,270,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,270,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,270,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,270,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,270,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,270,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,270,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,270,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,280,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,280,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,280,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,280,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,280,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,280,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,280,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,280,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,280,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,280,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,290,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,290,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,290,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,290,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,290,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,290,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,290,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,290,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,290,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,290,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,290,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,290,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,290,280)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 5 5v 70h 70v -70zM 15 15h 50v 50h -50z",
    transform: "rotate(0,40,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,30,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,30,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,30,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,40,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,40,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,40,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,50,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,50,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,50,50)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 225 5v 70h 70v -70zM 235 15h 50v 50h -50z",
    transform: "rotate(90,260,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,250,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,250,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,250,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,260,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,260,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,260,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,270,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,270,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,270,50)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 5 225v 70h 70v -70zM 15 235h 50v 50h -50z",
    transform: "rotate(-90,40,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,30,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,30,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,30,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,40,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,40,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,40,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,50,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,50,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,50,270)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrSouparceiroIos);
export default __webpack_public_path__ + "static/media/qr-souparceiro-ios.bd41c955da74c72f92ecc306106449e8.svg";
export { ForwardRef as ReactComponent };